import { OptionSelectionCounterFragment } from '@occc/graphql';
import { PiePieceItem } from '../../../../design-system';

export const convertOptionSelectionCountersToPieChartData = (
  optionSelectionCounters: OptionSelectionCounterFragment[] = [],
) =>
  optionSelectionCounters
    .map<PiePieceItem>((item) => ({
      name: item.optionLabel,
      value: item.count,
    }))
    .sort((a, b) => b.value - a.value);
